import Logger from 'es6/services/logger';

export default class SiteController {
  constructor(store, ...args) {
    this.store = store;
  }

  update(...params) {
    Logger.warn('update() undefined', this);
  }

  remove() {
    Logger.warn('remove() undefined', this);
  }
}
